import {
  ACTIVE_CLASS,
  BTN_PRIMARY_CLASS,
  BTN_SECONDARY_CLASS,
  SHOW_CLASS,
} from "../lib/constants";

const showDockByTabsPress = () => {
  const $tabsContainers = $(".js-tabs-container");
  const $boilerBtnContainer = $(".js-card-boiler-btn-container");

  $.each($tabsContainers, function (_, el) {
    const $tabsContainer = $(el);
    const $tabs = $tabsContainer.find("[data-tab]");

    $tabs.on("click", function () {
      const $tab = $(this);
      const tabsGroup = $tab.parent().attr("data-tabs-group");
      const $docks = $(`[data-dock-group=${tabsGroup}]`);

      if ($tabsContainer.hasClass("js-buy-tabs")) {
        if (!$tab.hasClass(ACTIVE_CLASS)) {
          $tabs
            .removeClass(ACTIVE_CLASS)
            .removeClass(BTN_PRIMARY_CLASS)
            .addClass("btn--primary-inv btn--bg-transparent");
          $tab
            .addClass(ACTIVE_CLASS)
            .addClass(BTN_PRIMARY_CLASS)
            .removeClass("btn--primary-inv btn--bg-transparent");

          $docks.removeClass(SHOW_CLASS);
          $(`[data-dock="${$tab.attr("data-tab")}"]`).addClass(SHOW_CLASS);
        }
      } else {
        if (!$tab.hasClass(ACTIVE_CLASS)) {
          $tabs.removeClass(ACTIVE_CLASS);
          $tab.addClass(ACTIVE_CLASS);

          $docks.removeClass(SHOW_CLASS);
          $(`[data-dock="${$tab.attr("data-tab")}"]`).addClass(SHOW_CLASS);

          if (tabsGroup === "info" && $tab.attr("data-tab") === "bonus") {
            $boilerBtnContainer.hide();
          } else {
            if (tabsGroup === "info") {
              $boilerBtnContainer.show();
            }
          }
        }
      }
    });
  });
};

export const tabsFunctions = () => {
  showDockByTabsPress();
};
